import WeatherSelectorTile from 'features/Weather/components/WeatherSelectorTile/WeatherSelectorTile';
import { getVisibleRange } from './utils/weatherSelectorTileList.utils';

const WeatherSelectorTileList = ({
  items = [],
  selectedIndex = 0,
  visibleNumOfItems = items.length,
  onSelect = () => {}, // Callback when a tile is selected, receives the selected item and index
  getKey = (item, index) => index, // Default key extractor if not provided
  getTileProps = (item, index) => ({}), // Function allows different items to have different props
  containerClassName = '',
  containerStyle,
  tileClassName = '',
  tileStyle,
}) => {
  const { startIndex, endIndex } = getVisibleRange({
    itemCount: items.length,
    selectedIndex,
    visibleNumOfItems,
  });

  const visibleItems = items
    .map((item, index) => ({ item: item, index }))
    .slice(startIndex, endIndex);

  return (
    <>
      {visibleItems.map(({ item, index }) => (
        <WeatherSelectorTile
          key={getKey(item, index)}
          selected={index === selectedIndex}
          buttonClassName={tileClassName}
          buttonStyle={tileStyle}
          onClick={() => onSelect(item, index)}
          {...getTileProps(item, index)}
        />
      ))}
    </>
  );
};

export default WeatherSelectorTileList;
